module.exports = __webpack_public_path__ + "static/media/traffic-event.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/traffic-event.svg
// module id = 947
// module chunks = 0